import React, { useState, useContext, useEffect } from 'react';
import { BearerTokenGetterContext } from '../../context/BearerTokenGetterContext.js';
import { api } from '../../services/api.js';
import { ModalDialog, Dialog } from '../dialog/index.js';
import styles from './media-link-dialog-header.module.css.js';

const TutorialModal = ({ closeTitle, tutorialId, onClose, studioGroup }) => {
    const [tutorial, setTutorial] = useState();
    const getBearerToken = useContext(BearerTokenGetterContext);
    useEffect(() => {
        const run = async () => {
            const token = await getBearerToken();
            const { data } = await api.get(`api/studio/tutorials/${tutorialId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    studioGroup,
                },
            });
            setTutorial(data);
        };
        run();
    }, [tutorialId, getBearerToken, studioGroup]);
    return tutorial ? (React.createElement(ModalDialog, { onClose: onClose, id: 'tutorial-dialog', closeTitle: closeTitle, className: styles.tutorialDialog },
        React.createElement(Dialog.Header, { title: tutorial.question }),
        React.createElement(Dialog.Body, { className: styles.tutorialDialogBody },
            React.createElement("iframe", { className: styles.vimeoIframe, src: `https://player.vimeo.com/video/${tutorial.vimeoId}`, title: tutorial.question })))) : null;
};

export { TutorialModal };
